/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RevisionTarget {
    getFixupPrototypeFunction() { return RevisionTarget.fixupPrototype; }

    static newInstance(model: Partial<RevisionTarget>): RevisionTarget {
        let obj = Object.assign(new RevisionTarget(), model);
        RevisionTarget.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RevisionTarget>): RevisionTarget {
        if (!model) return null;
        return RevisionTarget.newInstance(<RevisionTarget> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RevisionTarget) {
        if (!obj) return;

        models.RevisionTarget.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RevisionTarget): boolean {
        Object.setPrototypeOf(obj, RevisionTarget.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.block_index === undefined) {
            this.block_index = 0;
        }
    }

    /**
     * Turn whose HtmlPage or InsightPanel block is being revised; must belong to chat_id
     */
    conversation_id: string;

    /**
     * Index of the block inside that turn's persisted agent_response.response
     */
    block_index: number;

    /**
     * Saved artifact the block was opened from, when the revision started from an artifact
     */
    artifact_id: string;

}
